import { render, staticRenderFns } from "./beyannamerapor.vue?vue&type=template&id=27e0d87d"
import script from "./beyannamerapor.vue?vue&type=script&lang=js"
export * from "./beyannamerapor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports